import { toggleClass } from "../utils/dom-helpers.js";

function handleAccountMenuToggleClick(e) {
  e.preventDefault();
  toggleClass(this, "active");
  const menu = document.querySelector(".account-menu");
  if (menu) {
    // Using a simple display toggle
    if (menu.style.display === "none" || getComputedStyle(menu).display === "none") {
      menu.style.display = "block";
    } else {
      menu.style.display = "none";
    }
  }
}

export function initAccountMenu() {
  document.querySelectorAll(".account-menu-toggle").forEach((btn) => {
    btn.addEventListener("click", handleAccountMenuToggleClick);
  });
}
